import OptionsMenu, {
  OptionsMenuItem
} from "@pathwright/ux/src/components/menu/OptionsMenu"
import { ResourceFragment } from "@pathwright/graphql-client/src/generated"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { getPathUrl } from "../../utils/urls"

type ResourceOptionsMenuProps = {
  resource: ResourceFragment & {
    curriculum: {
      id: number
    } | null
  }
  settingsURL: string
}

const ResourceOptionsMenu = ({
  resource,
  settingsURL
}: ResourceOptionsMenuProps) => {
  const { me } = usePathwrightContext()

  const canEditLibrary =
    me?.permissions?.can_edit_library || me?.permissions?.can_administrate

  if (!resource || !settingsURL || !resource.curriculum?.id || !canEditLibrary)
    return null

  const sourcePathURL = getPathUrl(resource.slug, resource.curriculum?.id)

  return (
    <OptionsMenu>
      <OptionsMenuItem icon="gear" label="Edit Path Settings" to={settingsURL} />
      <OptionsMenuItem icon="group" label="Manage Cohorts" to={`${settingsURL}cohorts/`} />
      <OptionsMenuItem icon="path" label="View Source Path" to={sourcePathURL} />
    </OptionsMenu>
  )
}

export default ResourceOptionsMenu
